module.exports = __webpack_public_path__ + "media/images/icon-unlock-d8f82dcda64025c4cf198cb0db541574.svg";